import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=67803ccd&scoped=true&"
import script from "./footBar.vue?vue&type=script&lang=js&"
export * from "./footBar.vue?vue&type=script&lang=js&"
import style0 from "./footBar.vue?vue&type=style&index=0&id=67803ccd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67803ccd",
  null
  
)

export default component.exports